export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дүкенді таңдаңыз"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Атаусыз"])}
}